import { useTranslation } from 'react-i18next';
import SpirisIcon from '../Fundamentals/Icon/SpirisIcon';

const MyFeedbackList = ({ suggestions }) => {
    const { t } = useTranslation();

    if (!suggestions || suggestions.length === 0) {
        return <p className="text-secondary m-0">{t('feedback.emptyMine')}</p>;
    }

    return (
        <div className="d-flex flex-column">
            {suggestions.map((suggestion, index) => (
                <div key={suggestion.id} className={`d-flex align-items-center gap-12 py-12${index > 0 ? ' border-top' : ''}`}>
                    <div className="feedback-mine-visibility text-nowrap">
                        <span className={`d-inline-flex align-items-center gap-4 ${suggestion.isPublic ? 'label label-info' : 'text-secondary px-12'}`}>
                            <SpirisIcon name={suggestion.isPublic ? 'internet' : 'lock'} size="sm" />
                            {t(suggestion.isPublic ? 'feedback.visibilityPublic' : 'feedback.visibilityPrivate')}
                        </span>
                    </div>
                    <div className="feedback-suggestion-text flex-1 pt-2">{suggestion.suggestion}</div>
                    {suggestion.isPublic && (
                        <span className="d-flex align-items-center gap-4 ml-auto text-nowrap text-secondary">
                            <SpirisIcon name="star" size="sm" />
                            <span>{t('feedback.upvoteCount', { count: suggestion.upvoteCount })}</span>
                        </span>
                    )}
                </div>
            ))}
        </div>
    );
};

export default MyFeedbackList;
